<template>
  <div class="animated fadeIn absolute top-0 right-0 bottom-0 left-0">
    <div class="max-width-1 mx-auto relative center-y">
      <div class="clearfix">
        <div class="col-12 center">
          <div class="flex justify-start items-start mb3">
            <b-img src="../static/svg/padlock.svg" class="flex-none mr2" alt="" width="32" height="32" />
            <p class="gibson line-height-2 left-align">
              Sikkerhedsproblem. Du er allerede logget ind som en anden bruger.
            </p>
          </div>
          <a href="#/login" class="action-button mx-auto inline-block px2 py1 font-weight-bold">Login igen</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import loading from 'vue-full-loading'
export default {
  name: 'Security',
  components: {
    loading
  },
  data: function () {
    return {
      form: {
        username: '',
        password: '',
        errorMessage: ''
      },
      user: {
        name: '',
        token: '',
        role: ''
      },
      show: false,
      label: '',
      overlay: false
    }
  }
}
</script>
<style></style>


// WEBPACK FOOTER //
// Security.vue?560e4913